// extracted by mini-css-extract-plugin
export default {"layout":"LayoutDefault_layout__plrO4","sider":"LayoutDefault_sider__LuXBK","content":"LayoutDefault_content__V4mWM","footer":"LayoutDefault_footer__ZzPNI"};